import {useEffect, useState} from "react"

const Textarea = (props) => {
    const {name, value, label, className, error, required, counter, suffix, isReady, controlled = false, onChange, ...rest} = props
    const [inputValue, setInputValue] = useState(value ?? '')

    const handleChange = (ev) => {
        ev.preventDefault()
        if (controlled) {
            onChange?.(ev)
        } else {
            setInputValue(ev.target.value)
            onChange?.(ev)
        }
    }

    useEffect(() => {
        if (!controlled && value !== undefined) {
            setInputValue(value)
        }
    }, [value, controlled])

    const getInputLength = () => {
        let val = controlled ? value : inputValue
        let length = val?.length ?? 0;

        if(length > 0){
            const regex = /#(.*)\(\{[^{}]+\},\s*(\d+)\)/
            const found_function = val.match(regex);

            if (found_function) {
                length -= found_function[0].length
                length += + found_function[2];
            }
        }

        return length;
    }

    return (
        <div className="form-group">
            {label && <label>
                {required && <span className="text-red required">* </span>}
                {label}
                {error && <span className="error">{error}</span>}
            </label>}
            <div className="input-container">
                <textarea
                    rows={6}
                    name={name}
                    spellCheck={false}
                    disabled={!isReady}
                    value={controlled ? value ?? '' : inputValue}
                    className={`form-control form-control-sm ${className ? className : ''}`}
                    onChange={handleChange}
                    {...rest}
                />
                {counter && <span className="btn-addon">{getInputLength()}</span>}
                {suffix && <span className="suffix">{suffix}</span>}
            </div>
        </div>
    )
}

export default Textarea
